export const REGEX = {
    lettersAndNumbersOnly: /^[a-zA-Z0-9_ ]*$/
}